import classNames from "classnames";
import React from "react";
import ResetIcon from "../../../../../Icons/ResetIcon";
import ShowerIcon from "../../../../../Icons/ShowerIcon";

function ShowerModal({
  setOpen,
  habit,
  updateHabit,
  userChallenge,
  currentDay,
}) {
  const isHabitChecked = () => {
    return (
      userChallenge.dailyHabits["shower"] &&
      userChallenge.dailyHabits["shower"][currentDay] &&
      userChallenge.dailyHabits["shower"][currentDay] > 0
    );
  };

  return (
    <>
      {!isHabitChecked() ? (
        <div>
          <div className="w-8 w-8 mx-auto mb-4">
            <ShowerIcon />
          </div>
          <h1 className="font-extrabold text-2xl text-center">HITZE & KÄLTE</h1>

          <h5 className="text-sm mt-4 mb-6 font-extrabold text-center">
            Hast Du Dich heute extremer Hitze oder Kälte ausgesetzt?
          </h5>

          <p className="text-sm text-center">
            Für eine kalte Dusche, ein Eisbad oder einen Saunabesuch erhältst Du
            1 Punkt.
          </p>

          <button
            className={classNames(
              "bg-pink w-full block text-white font-extrabold p-4 rounded-full mt-12 transition-colors duration-300 ease-in-out mb-5"
            )}
            onClick={() => {
              updateHabit(1);
              setOpen(false);
            }}
          >
            FERTIG
          </button>

          <button
            className="w-full block text-white font-extrabold text-gray-300 mt-4"
            onClick={() => setOpen("keepup")}
          >
            ABBRECHEN
          </button>
        </div>
      ) : (
        <div className="w-full text-center">
          <div className="w-8 w-8 mx-auto mb-4">
            <ResetIcon />
          </div>
          <h1 className="font-extrabold text-2xl">PUNKTE WIDERRUFEN</h1>
          <h3 className="mt-4 text-sm mb-5">
            Hier kannst du deine Punkte zurücksetzen.
          </h3>

          <button
            className={classNames(
              "bg-pink w-full block text-white font-extrabold p-4 rounded-full transition-colors duration-300 ease-in-out"
            )}
            onClick={() => {
              updateHabit(0);
              setOpen(false);
            }}
          >
            PUNKTE WIDERRUFEN
          </button>

          <button
            className="w-full block text-white font-extrabold text-gray-300 mt-4 pb-8"
            onClick={() => setOpen(false)}
          >
            ABBRECHEN
          </button>
        </div>
      )}
    </>
  );
}

export default ShowerModal;
